namespace GeniuzPOS.Inventory {
    export interface IcStockTranRow {
        Id?: number;
        SkuCode?: string;
        TranDate?: string;
        TranTime?: string;
        TranType?: string;
        TranTypeDesc?: string;
        WhsId?: string;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        PostFg?: PostFgsStatus;
        Qty?: number;
        CostValue?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace IcStockTranRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'Inventory.IcStockTran';
        export const lookupKey = 'Inventory.IcStockTran';

        export function getLookup(): Q.Lookup<IcStockTranRow> {
            return Q.getLookup<IcStockTranRow>('Inventory.IcStockTran');
        }
        export const deletePermission = '2Inventory:ประวัติเคลื่อนไหวสต๊อก:View';
        export const insertPermission = '2Inventory:ประวัติเคลื่อนไหวสต๊อก:View';
        export const readPermission = '2Inventory:ประวัติเคลื่อนไหวสต๊อก:View';
        export const updatePermission = '2Inventory:ประวัติเคลื่อนไหวสต๊อก:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            TranDate = "TranDate",
            TranTime = "TranTime",
            TranType = "TranType",
            TranTypeDesc = "TranTypeDesc",
            WhsId = "WhsId",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            PostFg = "PostFg",
            Qty = "Qty",
            CostValue = "CostValue",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
